export const siteHealthLinks = [
  {
    to: '/audit/',
    title: 'Security Audit',
    description: 'Passive checks for public security and site-health signals'
  },
  {
    to: '/search-visibility/',
    title: 'Search & AI Visibility',
    description: 'Check whether search engines can find and understand your homepage'
  },
  {
    to: '/dns-health/',
    title: 'DNS Health',
    description: 'Review site reachability and common email-authentication records',
    primary: false
  },
  {
    to: '/ssl-checker/',
    title: 'SSL Checker',
    description: 'Inspect certificate validity, coverage, issuer, and expiry',
    primary: false
  }
];

export const domainToolLinks = [
  {
    to: '/generator/',
    title: 'AI Domain Generator',
    description: 'Generate meaningful names from a plain-English business idea'
  },
  {
    to: '/search/',
    title: 'Domain Search',
    description: 'Check point-in-time availability and registration data'
  },
  {
    to: '/premium/',
    title: 'Premium Domain Guide',
    description: 'Understand premium pricing and evaluate a domain'
  },
  {
    to: '/compare/',
    title: 'Compare Domains',
    description: 'Compare naming signals and public site-health observations'
  }
];

export const learnLinks = [
  {
    to: '/search-visibility/ai-crawler-registry/',
    title: 'AI Crawler Registry',
    description: 'Source-backed search, retrieval, and training crawler reference'
  },
  {
    to: '/search-visibility/methodology/',
    title: 'Visibility Methodology',
    description: 'See exactly what the search and AI visibility check measures'
  },
  {
    to: '/security/',
    title: 'Tech Stack Guides',
    description: 'Security guidance for common frameworks and platforms'
  },
  {
    to: '/blog/',
    title: 'Blog',
    description: 'Practical guides for domains, security, and discoverability'
  },
  {
    to: '/faq/',
    title: 'FAQ',
    description: 'Scanning boundaries, data handling, and product answers'
  },
  {
    to: '/glossary/',
    title: 'Glossary',
    description: 'Plain-English definitions for technical terms'
  }
];

export const navigationGroups = [
  {
    id: 'site-health',
    label: 'Site Health',
    description: 'Audit public website signals',
    links: siteHealthLinks
  },
  {
    id: 'domains',
    label: 'Domains',
    description: 'Generate, search, and compare names',
    links: domainToolLinks
  },
  {
    id: 'learn',
    label: 'Learn',
    description: 'Guides and reference material',
    links: learnLinks
  }
];

export const normalizeInternalPath = (path) => {
  if (!path || path === '/') return '/';
  return path.replace(/\/+$/, '');
};

export const isInternalPathActive = (pathname, target) => {
  const currentPath = normalizeInternalPath(pathname);
  const targetPath = normalizeInternalPath(target);

  if (targetPath === '/') return currentPath === '/';
  return currentPath === targetPath || currentPath.startsWith(`${targetPath}/`);
};
